import { render } from "./AddOns.vue?vue&type=template&id=981153be&scoped=true"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"

import "./AddOns.vue?vue&type=style&index=0&id=981153be&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981153be"]])

export default __exports__